import AppLayout from "../layout/AppLayout";
import MessageLayout from "../layout/messageLayout";
import Home from "../pages/message/home";
import MessageRoom from "../pages/message/room/indx";
import { AppRouteConfig } from "./route.types";

export const messageRoutes: AppRouteConfig[] = [
    {
      path: 'message',
      element: AppLayout,
      children: [
        {index: true, element: Home},
      ],
    },
    {
      path: 'message/room',
      element: MessageLayout,
      children: [
        {index: true, element: MessageRoom},
      ],
    },
  ];